import styled from 'styled-components';

export const JoinNowStyles = styled.div`
  .logo {
    svg {
      fill: ${props => props.theme.primaryDark};
    }
  }
  .login-now {
    margin-top: 1rem;
    text-align: center;
    color: #5F5F5F;
    a {
      color: inherit;
      text-decoration: underline;
    }
  }

  .error-message {
    color: #EE4C40;
    background: #FCE4E3;
    width: 750px;
    max-width: 100%;
    margin: auto;
    display: flex;
    padding: 6px 10px;
    text-align: left;
    img {
      margin-right: 10px;
      object-fit: contain;
    }
  }

  .title {
    font-family: "Poppins";
    margin-bottom: 0 !important;
  }

  .subtitle, .copy {
    font-family: "Inter";
  }

  .title, .subtitle, .copy, .meeting-with p {
    color: #5F5F5F;
  }
  .title {
    font-size: 1.5rem !important;
    font-weight: 300 !important;
    margin-bottom: 0.5rem !important;
    margin-top: 1rem !important;
    ${props => props.theme.media.md} {
      font-size: 2.7rem !important;
      font-weight: 400 !important;
    }
  }

  .subtitle {
    font-weight: 500;
    margin-bottom: 0.5rem;
    text-align: center;
  }

  .copy {
    line-height: 1.3;
    margin: 1em auto 2em;
    max-width: 42em;
    ${props => props.theme.media.md} {
      max-width: 433px;
    }
  }

  .custom-copy {
    text-align: center;

    ul {
      font-size: .85rem;
      line-height: 1.3;
      padding: 0;
      max-width: 595px;
      margin: auto;
      text-align: center;
      margin-bottom: 1rem;
      li {
        position: relative;
        list-style: none;
        counter-increment: listCounter 1;
        padding-left: 2rem;
        margin-bottom: 1.5rem;
        &:before {
          content: counter(listCounter);
          display: block;
          border-radius: 50%;
          background: rgb(63, 82, 97);
          position: absolute;
          font-weight: 500;
          text-align: center;
          width: 1.5rem;
          height: 1.5rem;
          justify-self: center;
          font-size: 0.8rem;
          line-height: 1.5rem;
          color: white;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
      }
    }
  }

  .accountant-details {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    margin-top: 1rem;

    .accountant-avatar {
      border-radius: 50%;
      height: auto;
      width: 80px;
    }

    .meeting-with {
      align-items: flex-start;
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin-left: 1rem;
      font-family: Inter;

      .top,
      .bottom {
        font-size: 18px;
      }

      .top {
        font-weight: 500;
        line-height: 0.875rem;
      }

      .bottom {
        font-weight: 300;
      }
    }
  }

  &.accounting-services-v2-business {
    .accountant-details {
      display: none;
    }
  }

  .sub-message {
    font-family: Inter;
    font-size: 18px;
    color: #5F5F5F;
    letter-spacing: 0px;
    margin-top: 25px;
    margin-bottom: 15px;
    color: #666;
    font-weight: 500;

    ${props => props.theme.media.lg} {
      font-size: 20px;
      margin-top: 5px;
      margin-bottom: 25px;
    }
  }

  .scheduler-testimonial {
    margin: auto;
    margin-top: 15px;
    padding: 0;
    text-align: center;
    display: block;
    ${props => props.theme.media.lg} {
      margin-top: 25px;
      display: flex;
    }
    img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin-right: 0;
      margin-bottom: 10px;
      ${props => props.theme.media.lg} {
        margin-right: 10px;
        width: 110px;
        height: 110px;
      }
    }
    .text {
      color: #666;
      font-size: 18px;
      font-weight: 500;
    }
    .author {
      color: #666;
      font-size: 18px;
      font-weight: 400;
    }
  }
`;
